import type React from 'react';

import { translationKey } from '@change-corgi/core/i18n';

import type { RecommendedGroup } from '#src/app/pages/starterDashboardV2/shared/types';

import type { RecommendedGroupWithPlatform } from '../../../../hooks/useSharingTools/types';
import { SharingToolsCardWrapper } from '../../../SharingToolsCardWrapper';
import { RecommendedGroupsCardsContainer } from '../RecommendedGroupCardsContainer';
import { RecommendedGroupsCardLoading } from '../RecommendedGroupsCardLoading';

type RecommendedGroupsCardPreviewProps = Readonly<{
	recommendedGroups: {
		isLoading: boolean;
		groups: readonly RecommendedGroupWithPlatform[];
	};
	primaryAction?: () => void;
	onFacebookGroupClick?: (group: RecommendedGroup) => void;
	onRedditGroupClick?: (group: RecommendedGroup) => void;
}>;

export const RecommendedGroupsCardPreview: React.FC<RecommendedGroupsCardPreviewProps> = ({
	recommendedGroups,
	primaryAction = () => {},
	onFacebookGroupClick,
	onRedditGroupClick,
}) => {
	const { isLoading, groups } = recommendedGroups;

	if (!isLoading && groups.length === 0) {
		return null;
	}

	const preview = isLoading ? (
		<RecommendedGroupsCardLoading />
	) : (
		<RecommendedGroupsCardsContainer
			groups={groups}
			onFacebookGroupClick={onFacebookGroupClick}
			onRedditGroupClick={onRedditGroupClick}
		/>
	);

	return (
		<SharingToolsCardWrapper
			Preview={preview}
			titleKey={translationKey('corgi.petition.starter_dashboard_v2.sharing_tools.recommended_groups.title')}
			descriptionKey={translationKey(
				'corgi.petition.starter_dashboard_v2.sharing_tools.recommended_groups.description',
			)}
			primaryActionTextKey={translationKey(
				'corgi.petition.starter_dashboard_v2.sharing_tools.recommended_groups.primary_action_text',
			)}
			primaryActionOnClick={primaryAction}
		/>
	);
};
